import { render, staticRenderFns } from "./ChioseDialog.vue?vue&type=template&id=1c47ff7c&scoped=true&"
import script from "./ChioseDialog.vue?vue&type=script&lang=js&"
export * from "./ChioseDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChioseDialog.vue?vue&type=style&index=0&id=1c47ff7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c47ff7c",
  null
  
)

export default component.exports